import React, { memo } from 'react';
import classnames from 'classnames';
import { urlWithSizeEx } from 'Shared/ImageFallback';
import NormalContentCard from './NormalContentCard';
import ImageContentCard from './ImageContentCard';
import LargeContentCard from './LargeContentCard';
const noImage = require('styles/images/missingImage.svg');
const DEFAULT_APPEARANCE = 'content';
const cardAppearances = {
    ['content']: NormalContentCard,
    ['medium']: ImageContentCard,
    ['large']: LargeContentCard,
    ['largeOnlyImage']: ImageContentCard,
};
const appearanceTypeImage = (props) => ({
    content: () => urlWithSizeEx(props.contentCardImage, 'content'),
    medium: () => urlWithSizeEx(props.mediumContentCardImage, 'medium'),
    large: () => urlWithSizeEx(props.largeContentCardImage, 'large'),
    largeOnlyImage: () => urlWithSizeEx(props.largeContentCardImage, 'large'),
    all: () => urlWithSizeEx(props.contentCardImage, 'content'),
    news: () => urlWithSizeEx(props.contentCardImage, 'content'),
});
const getAppearance = (props) => (props.showAll && props.appearance === 'content'
    ? 'all'
    : props.isNews && props.appearance === 'content'
        ? 'news'
        : props.appearance === 'large' && !!!props.text
            ? 'largeOnlyImage'
            : props.appearance) || DEFAULT_APPEARANCE;
const getCardType = (props) => (props.appearance === 'large' && !!!props.text
    ? 'largeOnlyImage'
    : props.appearance || DEFAULT_APPEARANCE);
const getImage = (props) => appearanceTypeImage(props)[getAppearance(props)]() || noImage;
export default memo((props) => React.createElement(cardAppearances[getCardType(props)], Object.assign({}, props, {
    imageUrl: getImage(props),
    appearance: getAppearance(props),
    className: classnames('ui-test-content-card', props.className),
})));
